module.exports = __webpack_public_path__ + "static/media/683DalvigneyStNW_2018-06-25_186.9982b249.jpg";